import { infiniteListQueryOptions as e } from "./infiniteListQueryOptions.mjs";
import { useInfiniteList as t } from "./useInfiniteList.mjs";
import { useInfiniteQuery as n } from "./useInfiniteQuery.mjs";
//#region src/hooks/useInfiniteListQuery.ts
function r(r) {
	let { key: i, ...a } = r;
	return t(n(e(a)), i);
}
//#endregion
export { r as useInfiniteListQuery };
